import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { CurrencyMaskModule } from "ngx-currency-mask";
import { NgxPaginationModule } from 'ngx-pagination';
import { OrderModule } from 'ngx-order-pipe';
import { RolResponsaveisPage } from './rol-responsaveis/rol-responsaveis';
import { DadosGeraisPage } from '../dados-gerais/dados-gerais';

import { QuillModule } from 'ngx-quill';

import { CargoPage } from '../cargo/cargo';
import { BensServicosPage } from '../bens-servicos/bens-servicos';
import { EspeciesProcessuaisPage } from '../especies-processuais/especies-processuais';
import { LicitacaoResumoAnalisePage } from './licitacao/resumo-analise/resumo-analise';
import { DirecionamentoFornecedoresPage } from './licitacao/direcionamento-fornecedores/direcionamento-fornecedores';
import { VisaoGerencialPage } from './licitacao/visao-gerencial/visao-gerencial';
import { VisaoGerencialPessoalPage } from './pessoal/visao-gerencial/visao-gerencial';
import { VisaoGerencialElemento31Page } from './pessoal/visao-gerencial-elemento-31/visao-gerencial-elemento-31';
import { LicitacaoRelatorioInspecaoPage } from './licitacao/relatorio-inspecao/relatorio-inspecao';
import { BensServicosConviteTomadaConcorrenciaPage } from './licitacao/bens-servicos-convite-tomada-concorrencia/bens-servicos-convite-tomada-concorrencia';
import { BensServicosNaoEnquadramPage } from './licitacao/bens-servicos-nao-enquadram/bens-servicos-nao-enquadram';
import { DispensaLicitacaoIncompativelPage } from './licitacao/dispensa-licitacao-incompativel/dispensa-licitacao-incompativel';
import { InexigibilidadePage } from './licitacao/inexigibilidade/inexigibilidade';
import { OutrosServicosLimiteDispensaPage } from './licitacao/outros-servicos-limite-dispensa/outros-servicos-limite-dispensa';
import { ModalidadeVersusContratadoPage } from './licitacao/modalidade-versus-contratado/modalidade-versus-contratado';
import { ObrasAcimaLimitePage } from './licitacao/obras-acima-limite/obras-acima-limite';

import { PessoalResumoAnalisePage } from './pessoal/resumo-analise/resumo-analise';
import { PessoalAnaliseHorizontalPage } from './pessoal/analise-horizontal/analise-horizontal';
import { PessoalAnaliseVerticalPage } from './pessoal/analise-vertical/analise-vertical';
import { PessoalNomeacaoVersusParametrizacaoPage } from './pessoal/nomeacao-versus-parametrizacao/nomeacao-versus-parametrizacao';
import { PessoalNomeacaoVersusSRPPage } from './pessoal/nomeacao-versus-srp/nomeacao-versus-srp';
import { PessoalVersusNomeacaoPage } from './pessoal/pessoal-versus-nomeacao/pessoal-versus-nomeacao';
import { PessoalQuadroPessoalPage } from './pessoal/quadro-pessoal/quadro-pessoal';
import { PessoalTermosReferenciaContratoPage } from './pessoal/termos-referencia-contrato/termos-referencia-contrato';

import { PessoalQuadroNomeacaoCargosPage } from './pessoal/quadro-nomeacao-cargos/quadro-nomeacao-cargos';
import { PessoalDemQuadroPessoallPage } from './pessoal/dem-quadro-pessoal/dem-quadro-pessoal';
import { PessoalContratosTerceirizacaolPage } from './pessoal/contratos-terceirizacao/contratos-terceirizacao';

import { MonitoramentoDecisoesPage } from './monitoramento-decisoes/determinacoes/determinacoes';
import { MonitoramentoDecisoesResumoAnalisePage } from './monitoramento-decisoes/resumo-analise/resumo-analise';

import { TomadaDeContaResumoAnalisePage } from './tce/tce-resumo-acoes/tce-resumo-acoes';
import { TomadaDeContaPage } from './tce/tce-exercicio/tce-exercicio';


import { diferencaDotacoesPage } from './orcamento/analista/diferencaDotacoes/diferencaDotacoes';
import { consolidacaoDespesasPage } from './orcamento/analista/consolidacaoDespesas/consolidacaoDespesas';
import { AnaliseMetasPage } from './orcamento/analista/analise-metas/analise-metas';
import { AquisicaoBensPage } from './orcamento/analista/aquisicaoBens/aquisicaoBens';
import { ExecucaoXMetasPage } from './orcamento/analista/execucaoXmetas/execucaoXmetas';
import { ExerciciosAnterioresPage } from './orcamento/analista/exerciciosAnteriores/exerciciosAnteriores';

// **
// ** GM
// ** 
import { BaixaVsAquisicaoPage } from './materiais/analista/baixa-vs-aquisicao/baixa-vs-aquisicao';
import { BaixaVsSaldoAtualPage } from './materiais/analista/baixa-vs-saldo/baixa-vs-saldo';
import { ReconhecimentoResultadoPage } from './materiais/analista/reconhecimento-resultado/reconhecimento-resultado';
import { AlienacoesDoacoesPage } from './materiais/analista/alienacoes-doacoes/alienacoes-doacoes';
import { SaldosContabeisPage } from './materiais/analista/saldos-contabeis/saldos-contabeis';
import { SaldosContabeisTabelasVsBalancetePage } from './materiais/analista/saldos-contabeis-tabelas-vs-balancete/saldos-contabeis-tabelas-vs-balancete';

// **
// ** CONVÊNIOS
// ** 
import { ConvenioResumoAnalisePage } from './convenios/resumo-analise/resumo-analise';
import { ConvenioRelacaoCelebradosPage } from './convenios/relacao-celebrados/relacao-celebrados';
import { ConvenioComunicacaoInadimplenciaPage } from './convenios/comunicacao-inadimplencia/comunicacao-inadimplencia';
import { ResumoRelatorioInspecaoConveniosPage } from './convenios/convenio-analise/resumo-relatorio-inspecao/resumo-relatorio-inspecao';
import { CelebracaoInadimplentePage } from './convenios/convenio-analise/celebracao-inadimplente/celebracao-inadimplente'
import { ParcelaUnicaPage } from './convenios/convenio-analise/parcela-unica/parcela-unica';
import { ApresentacaoFPrazoPage } from './convenios/convenio-analise/apresentacao-fora-prazo/apresentacao-fora-prazo';
import { SaldoRemanescentePage } from './convenios/convenio-analise/saldo-remanescente/saldo-remanescente';
import { PrestacaoSuperiorPage } from './convenios/convenio-analise/prestacao-superior/prestacao-superior';
import { SaldosADevolverPage } from './convenios/convenio-analise/saldo-a-devolver/saldo-a-devolver';
import { PrestacaoForaPrazoPage } from './convenios/convenio-analise/prestacao-fora-prazo/prestacao-fora-prazo';
import { CelebracaoAtrasoPage } from './convenios/convenio-analise/celebracao-atraso/celebracao-atraso';
import { RegistroIncorretoPage } from './convenios/convenio-analise/registro-incorreto/registro-incorreto';
import { ConveniosInadimplenciaPage } from './convenios/convenio-analise/convenios-inadimplencia/convenios-inadimplencia';
import { ComunicacaoInadimplenciaPage } from './convenios/convenio-analise/comunicacao-inadimplencia/comunicacao-inadimplencia';
import { DesconformidadePublicacaoPage } from './convenios/convenio-analise/desconformidade-publicacao/desconformidade-publicacao';
import { EmpenhoAssinaturaPage } from './convenios/convenio-analise/empenho-assinatura/empenho-assinatura';
import { EmpenhoPublicacaoPage } from './convenios/convenio-analise/empenho-publicacao/empenho-publicacao';
import { EmpenhoVigenciaPage } from './convenios/convenio-analise/empenho-vigencia/empenho-vigencia';
import { RelatorioAuditoriaCGEPage } from './convenios/convenio-analise/relatorio-auditoria-cge/relatorio-auditoria-cge';
import { MedidasForaPrazoPage } from './convenios/convenio-analise/medidas-fora-prazo/medidas-fora-prazo';

import { MateriaisResumoAnalisePage } from './materiais/resumo-analise/resumo-analise';
import { MateriaisConsumoPage } from './materiais/materiais-consumo/materiais-consumo';
import { BensMateriaisMoveisPage } from './materiais/bens-moveis/bens-moveis';
import { BensMateriaisImoveisPage } from './materiais/bens-imoveis/bens-imoveis';
import { BensMateriaisIntangiveisPage } from './materiais/bens-intangiveis/bens-intangiveis';

import { AlienacaoBensMoveisPage } from './materiais/alienacao-bens-moveis/alienacao-bens-moveis';
import { AlienacaoBensImoveisPage } from './materiais/alienacao-bens-imoveis/alienacao-bens-imoveis';

import { BensDoacaoPage } from './materiais/bens-doacao/bens-doacao';

import { ContabilidadeResumoAnalisePage } from './relatorios-contabeis/resumo-acoes/resumo-acoes';

import { ControlesInternosPage } from './controles-internos/controles-internos';
import { ProcessosCorrelatosPage } from './processos-correlatos/processos-correlatos';
import { RelatoriosContabeisPage } from './relatorios-contabeis/pecas-processuais/relatorios-contabeis';
import { OrcamentoResumoAnalisePage } from './orcamento/resumo-acoes/resumo-acoes';
import { ContratosGestaoResumoAnalisePage } from './contratos-gestao/resumo-acoes/resumo-acoes';
import { ContasBancariasPage } from './relatorios-contabeis/contas-bancarias/contas-bancarias';
import { ContratosPage } from './contratos/contratos';

import { AnaliseHorizontalBalancoPatrimonialPage } from './modulo-analise/analise-horizontal/balanco-patrimonial/balanco-patrimonial';
import { AnaliseHorizontalBalancoDvpPage } from './modulo-analise/analise-horizontal/balanco-dvp/balanco-dvp';
import { AnaliseVerticalBalancoPatrimonialPage } from './modulo-analise/analise-vertical/balanco-patrimonial/balanco-patrimonial';
import { AnaliseHorizontalBalancoFinanceiroPage } from './modulo-analise/analise-horizontal/balanco-financeiro/balanco-financeiro';
import { AnaliseHorizontalDemonstrativoFluxoCaixaPage } from './modulo-analise/analise-horizontal/demonstrativo-fluxo-caixa/demonstrativo-fluxo-caixa';
import { ExecucaoRestosPagarPage } from './modulo-analise/execucao-restos-pagar/execucao-restos-pagar';
import { ValoresRestituiveisPage } from './modulo-analise/valores-restituiveis/valores-restituiveis';
import { SaldoCaixaPage } from './modulo-analise/saldo-caixa/saldo-caixa';
import { SaldoContaPage } from './modulo-analise/saldo-conta/saldo-conta';
import { SaldoContaSPEDPage } from './modulo-analise/saldo-conta-sped/saldo-conta';
import { ValidacaoConsistenciaBalancoPatrimonialPage } from './modulo-analise/validacao-consistencia/balanco-patrimonial/balanco-patrimonial';
import { ValidacaoConsistenciaBalancoPatrimonialSPEDPage } from './modulo-analise/validacao-consistencia/balanco-patrimonial-sped/balanco-patrimonial';
import { ValidacaoConsistenciaBalancoDVPPage } from './modulo-analise/validacao-consistencia/balanco-dvp/balanco-dvp';
import { ValidacaoConsistenciaBalancoDFCPage } from './modulo-analise/validacao-consistencia/balanco-dfc/balanco-dfc';
import { ValidacaoConsistenciaBalancoFinanceiroPage } from './modulo-analise/validacao-consistencia/balanco-financeiro/balanco-financeiro';
import { CruzamentoBalancoFinanceiroPatrimonialPage } from './modulo-analise/cruzamento/balanco-financeiro-patrimonial/balanco-financeiro-patrimonial';
import { TotalRestosPagarNaoProcessadosPage } from './modulo-analise/total-restos-pagar-nao-processados/total-restos-pagar-nao-processados';
import { ExecucaoRestosPagarNaoProcessadosPage } from './modulo-analise/execucao-restos-pagar-nao-processados/execucao-restos-pagar-nao-processados';
import { AnaliseContasBancariasPage } from './modulo-analise/contas-bancarias/contas-bancarias';
import { SaldosDeclaradosPage } from './modulo-analise/saldos-declarados/saldos-declarados';
 
import { ListaContratosPage } from './contratos/contrato-analise/lista-contratos/lista-contratos';
import { ResumoRelatorioInspecaoPage } from './contratos/contrato-analise/resumo-relatorio-inspecao/resumo-relatorio-inspecao';
import { AcrescimosOuSupressoesContratosVersusLimiteLegalPage } from './contratos/contrato-analise/acrescimo-supressoes-contratos-versus-limite-legal/acrescimo-supressoes-contratos-versus-limite-legal';
import { ExtensaoPrazosContratuaisAcimaLimiteRegulamentadoPage } from './contratos/contrato-analise/extensao-prazos-contratuais-acima-limite-regulamentado/extensao-prazos-contratuais-acima-limite-regulamentado';
import { NotaEmpenhoAnteriorAAssinaturaContratoPage } from './contratos/contrato-analise/nota-empenho-anterior-assinatura-contrato/nota-empenho-anterior-assinatura-contrato';
import { NotaEmpenhoAnteriorAPublicacaoContratoPage } from './contratos/contrato-analise/nota-empenho-anterior-publicacao-contrato/nota-empenho-anterior-publicacao-contrato';
import { NotaEmpenhoPosteriorAVigenciaContratoPage } from './contratos/contrato-analise/nota-empenho-posterior-vigencia-contrato/nota-empenho-posterior-vigencia-contrato';
import { RegistroDespesasSemContratoDesacordoArt62Page } from './contratos/contrato-analise/registro-despesas-sem-contrato-desacordo-art62/registro-despesas-sem-contrato-desacordo-art62';
import { ValidacaoDataPublicacaoPage } from './contratos/contrato-analise/validacao-data-publicacao/validacao-data-publicacao';

import { CadastroContratosPage } from './contratos-gestao/cadastro-contratos/cadastro-contratos';
import { RolResponsaveisCGPage } from './contratos-gestao/rol-responsaveis/rol-responsaveis';
import { TransferenciaRecursosPage } from './contratos-gestao/transferencia-recursos/transferencia-recursos';
import { RelatorioReceitasDespesasPage } from './contratos-gestao/relatorio-receitas-despesas/relatorio-receitas-despesas';
import { RelatorioPagamentosPage } from './contratos-gestao/relatorio-pagamentos/relatorio-pagamentos';
import { RelatorioFisicoFinanceiroPage } from './contratos-gestao/relatorio-fisico-financeiro/relatorio-fisico-financeiro';
import { RelatorioEditaisCotacoesPage } from './contratos-gestao/relatorio-editais-cotacoes/relatorio-editais-cotacoes';
import { PessoalVinculadoPage } from './contratos-gestao/pessoal-vinculado/pessoal-vinculado';

import { AnaliseDespesasPage } from './contratos-gestao/analista/analise-despesas/analise-despesas';
import { PagamentosDesacordoCompraPage } from './contratos-gestao/analista/pagamentos-desacordo-compra/pagamentos-desacordo-compra';
import { PagamentosVsPessoalPage } from './contratos-gestao/analista/pagamentos-vs-pessoal/pagamentos-vs-pessoal';
import { ParcelasRecebidasVsEmpenhoPage } from './contratos-gestao/analista/parcelas-recebidas-vs-empenho/parcelas-recebidas-vs-empenho';
import { RelatorioFisicoPage } from './contratos-gestao/analista/relatorio-fisico/relatorio-fisico';
import { RelatorioReceitaDespesaPage } from './contratos-gestao/analista/relatorio-receita-despesa/relatorio-receita-despesa';
import { TransferenciaRecursosAnalistaPage } from './contratos-gestao/analista/transferencia-recursos/transferencia-recursos-analista';
import { VerificacaoContratacaoPage } from './contratos-gestao/analista/verificacao-contratacao/verificacao-contratacao';
import { VerificacaoRolPage } from './contratos-gestao/analista/verificacao-rol/verificacao-rol';
import { ServidoresContempladosPagamentosPage } from './contratos-gestao/analista/servidores-contemplados-pagamentos/servidores-contemplados-pagamentos';
import { PessoalVinculadoCGPage } from './contratos-gestao/analista/pessoal-vinculado/pessoal-vinculado';


import { ArquivosPage } from './arquivos/arquivos';

import { ResumoAnalisePage } from './modulo-analise/resumo-analise/resumo-analise';

import { ControlesinternosValidator } from '../../pipes/controlesinternos-validator';
//import { GroupByPipe } from '../../pipes/group-by';
import { Autoresize } from '../../pipes/autoresize';
import { PipesModule } from '../../pipes/pipes.module';
import { MyFilterPipe } from '../../pipes/filtro-ng-for';
import { TipoContaFilter } from '../../pipes/tipo-conta-filter';
import { TipoBancoFilter } from '../../pipes/tipo-banco-filter';
import { FonteDiferencaFilter } from '../../pipes/tipo-fonte-diferenca-filter';
import { OrderrByPipe } from '../../pipes/orderby-filter';
import { FiltroProcessoPipe } from '../../pipes/filtro-processo';
import { FiltroRespostaValor } from '../../pipes/filtro-resposta-valor';
import { TextMaskModule } from 'angular2-text-mask';
import { FormsModule } from '@angular/forms';

import { MyDatePickerModule } from 'mydatepicker';
import { MyDateRangePickerModule } from 'mydaterangepicker';

import { NgPipesModule } from 'ngx-pipes';
import { RolAssinantesPage } from "./rol-assinantes/rol-assinantes";
import { CadastroAssinantesPage } from "./rol-assinantes/cadastro-assinante";
import { NgSelectModule } from "@ng-select/ng-select";
import { TCEForaDoPrazoPage } from "./tce/tce-fora-do-prazo/tce-fora-do-prazo";
import { TCEConveniosPrestacaoPendentesPage } from "./tce/tce-pendentes/tce-pendentes";
import { TCENaoEnviadoPage } from "./tce/tce-nao-enviado/tce-nao-enviado";

import { ValidacaoContasTotalizadorasDVPPage } from './modulo-analise/validacao-contas-totalizadoras/balanco-dvp/balanco-dvp';
import { ValidacaoContasTotalizadorasDemonstrativoFluxoCaixaPage } from './modulo-analise/validacao-contas-totalizadoras/demonstrativo-fluxo-caixa/demonstrativo-fluxo-caixa';
import { ValidacaoContasTotalizadorasBalancoOrcamentarioPage } from './modulo-analise/validacao-contas-totalizadoras/balanco-orcamentario/balanco-orcamentario';
import { ValidacaoContasTotalizadorasBalancoFinanceiroPage } from './modulo-analise/validacao-contas-totalizadoras/balanco-financeiro/balanco-financeiro';
import { ValidacaoContasTotalizadorasBalancoPatrimonialPage } from './modulo-analise/validacao-contas-totalizadoras/balanco-patrimonial/balanco-patrimonial';
import { AnaliseIndicadoresPage } from './modulo-analise/indicadores/indicadores';
import { AnalisePrevisaoInicialContasAnaliticasPage } from './modulo-analise/previsao-inicial-contas-analiticas/previsao-inicial-contas-analiticas';
import { ExecucaoRestosPagarProcessadosLiquidadosPage } from './modulo-analise/execucao-restos-pagar-processados-liquidados/execucao-restos-pagar-processados-liquidados';
import { AnaliseSaldosViradosDVPPage } from './modulo-analise/saldos-virados/saldos-virados-dvp/saldos-virados-dvp';
import { AnaliseSaldosViradosFinanceiroPage } from './modulo-analise/saldos-virados/saldos-virados-financeiro/saldos-virados-financeiro';
import { AnaliseSaldosViradosDemonstrativoFluxoCaixaPage } from './modulo-analise/saldos-virados/saldos-virados-demonstrativo-fluxo-caixa/saldos-virados-demonstrativo-fluxo-caixa';
import { AnaliseSaldosViradosPatrimonialPage } from './modulo-analise/saldos-virados/saldos-virados-patrimonial/saldos-virados-patrimonial';
import { AnaliseSaldosViradosPatrimonialSPEDPage } from './modulo-analise/saldos-virados/saldos-virados-patrimonial-sped/saldos-virados-patrimonial-sped';
import { AnaliseSaldosViradosOrcamentarioPage } from './modulo-analise/saldos-virados/saldos-virados-orcamentario/saldos-virados-orcamentario';
import { TotalRestosPagarProcessadosPage } from './modulo-analise/total-restos-pagar-processados/total-restos-pagar-processados';
import { SaldoContasAnaliticasPage } from './modulo-analise/saldo-contas-analiticas/saldo-contas-analiticas';
import { OrdinariaVsVinculadaPage } from './modulo-analise/ordinaria-vs-vinculada/ordinaria-vs-vinculada';

import { AnaliseHorizontalBalancoPatrimonialEGEPage } from './modulo-analise/analise-horizontal/balanco-patrimonial-ege/balanco-patrimonial';
import { AnaliseHorizontalBalancoDvpEGEPage } from './modulo-analise/analise-horizontal/balanco-dvp-ege/balanco-dvp';
import { AnaliseVerticalBalancoPatrimonialEGEPage } from './modulo-analise/analise-vertical/balanco-patrimonial-ege/balanco-patrimonial';
import { AnaliseVerticalBalancoPatrimonialSpedPage } from './modulo-analise/analise-vertical/balanco-patrimonial-sped/balanco-patrimonial';

import { AnaliseHorizontalBalancoFinanceiroEGEPage } from './modulo-analise/analise-horizontal/balanco-financeiro-ege/balanco-financeiro';
import { AnaliseHorizontalDemonstrativoFluxoCaixaEGEPage } from './modulo-analise/analise-horizontal/demonstrativo-fluxo-caixa-ege/demonstrativo-fluxo-caixa';
import { ExecucaoRestosPagarEGEPage } from './modulo-analise/execucao-restos-pagar-ege/execucao-restos-pagar';
import { ValoresRestituiveisEGEPage } from './modulo-analise/valores-restituiveis-ege/valores-restituiveis';
import { SaldoCaixaEGEPage } from './modulo-analise/saldo-caixa-ege/saldo-caixa';
import { SaldoContaEGEPage } from './modulo-analise/saldo-conta-ege/saldo-conta';
import { ValidacaoConsistenciaBalancoDFCEGEPage } from './modulo-analise/validacao-consistencia/balanco-dfc-ege/balanco-dfc';
import { ValidacaoConsistenciaBalancoPatrimonialEGEPage } from './modulo-analise/validacao-consistencia/balanco-patrimonial-ege/balanco-patrimonial';
import { ValidacaoConsistenciaBalancoDVPEGEPage } from './modulo-analise/validacao-consistencia/balanco-dvp-ege/balanco-dvp';
import { ValidacaoConsistenciaBalancoFinanceiroEGEPage } from './modulo-analise/validacao-consistencia/balanco-financeiro-ege/balanco-financeiro';
import { CruzamentoBalancoFinanceiroPatrimonialEGEPage } from './modulo-analise/cruzamento/balanco-financeiro-patrimonial-ege/balanco-financeiro-patrimonial';
import { TotalRestosPagarNaoProcessadosEGEPage } from './modulo-analise/total-restos-pagar-nao-processados-ege/total-restos-pagar-nao-processados';
import { ExecucaoRestosPagarNaoProcessadosEGEPage } from './modulo-analise/execucao-restos-pagar-nao-processados-ege/execucao-restos-pagar-nao-processados';
import { AnaliseContasBancariasEGEPage } from './modulo-analise/contas-bancarias-ege/contas-bancarias';
import { SaldosDeclaradosEGEPage } from './modulo-analise/saldos-declarados-ege/saldos-declarados';
import { ValidacaoContasTotalizadorasBalancoFinanceiroEGEPage } from './modulo-analise/validacao-contas-totalizadoras/balanco-financeiro-ege/balanco-financeiro';
import { ValidacaoContasTotalizadorasBalancoOrcamentarioEGEPage } from './modulo-analise/validacao-contas-totalizadoras/balanco-orcamentario-ege/balanco-orcamentario';
import { ValidacaoContasTotalizadorasBalancoPatrimonialEGEPage } from './modulo-analise/validacao-contas-totalizadoras/balanco-patrimonial-ege/balanco-patrimonial';
import { ValidacaoContasTotalizadorasBalancoPatrimonialSPEDPage } from './modulo-analise/validacao-contas-totalizadoras/balanco-patrimonial-sped/balanco-patrimonial';
import { ValidacaoContasTotalizadorasDRESPEDPage } from './modulo-analise/validacao-contas-totalizadoras/dre-sped/dre';

import { ValidacaoContasTotalizadorasDemonstrativoFluxoCaixaEGEPage } from './modulo-analise/validacao-contas-totalizadoras/demonstrativo-fluxo-caixa-ege/demonstrativo-fluxo-caixa';
import { ValidacaoContasTotalizadorasDVPEGEPage } from './modulo-analise/validacao-contas-totalizadoras/balanco-dvp-ege/balanco-dvp';
import { AnalisePrevisaoInicialContasAnaliticasEGEPage } from './modulo-analise/previsao-inicial-contas-analiticas-ege/previsao-inicial-contas-analiticas';
import { AnaliseIndicadoresEGEPage } from './modulo-analise/indicadores-ege/indicadores';
import { ExecucaoRestosPagarProcessadosLiquidadosEGEPage } from './modulo-analise/execucao-restos-pagar-processados-liquidados-ege/execucao-restos-pagar-processados-liquidados';
import { AnaliseSaldosViradosDVPEGEPage } from './modulo-analise/saldos-virados/saldos-virados-dvp-ege/saldos-virados-dvp';
import { AnaliseSaldosViradosFinanceiroEGEPage } from './modulo-analise/saldos-virados/saldos-virados-financeiro-ege/saldos-virados-financeiro';
import { AnaliseSaldosViradosDemonstrativoFluxoCaixaEGEPage } from './modulo-analise/saldos-virados/saldos-virados-demonstrativo-fluxo-caixa-ege/saldos-virados-demonstrativo-fluxo-caixa';
import { AnaliseSaldosViradosPatrimonialEGEPage } from './modulo-analise/saldos-virados/saldos-virados-patrimonial-ege/saldos-virados-patrimonial';
import { AnaliseSaldosViradosOrcamentarioEGEPage } from './modulo-analise/saldos-virados/saldos-virados-orcamentario-ege/saldos-virados-orcamentario';
import { TotalRestosPagarProcessadosEGEPage } from './modulo-analise/total-restos-pagar-processados-ege/total-restos-pagar-processados';
import { SaldoContasAnaliticasEGEPage } from './modulo-analise/saldo-contas-analiticas-ege/saldo-contas-analiticas';
import { OrdinariaVsVinculadaEGEPage } from './modulo-analise/ordinaria-vs-vinculada-ege/ordinaria-vs-vinculada';

import { AnaliseHorizontalBalancoPatrimonialSpedPage } from './modulo-analise/analise-horizontal/balanco-patrimonial-sped/balanco-patrimonial';
import { AssinaturaModule } from '../../assinatura/assinatura.module';

@NgModule({
    declarations: [
        ControlesInternosPage,
        RolResponsaveisPage,
        RolAssinantesPage,
        CadastroAssinantesPage,
        DadosGeraisPage,
        ProcessosCorrelatosPage,
        RelatoriosContabeisPage,
        OrcamentoResumoAnalisePage,
        ContasBancariasPage,
        ContratosPage,
        AnaliseHorizontalBalancoPatrimonialPage,
        AnaliseHorizontalBalancoDvpPage,
        AnaliseVerticalBalancoPatrimonialPage,
        AnaliseHorizontalBalancoFinanceiroPage,
        AnaliseHorizontalDemonstrativoFluxoCaixaPage,
        ExecucaoRestosPagarPage,
        ValoresRestituiveisPage,
        SaldoCaixaPage,
        TotalRestosPagarNaoProcessadosPage,
        ExecucaoRestosPagarNaoProcessadosPage,
        SaldoContaPage,
        SaldoContaSPEDPage,
        ValidacaoConsistenciaBalancoPatrimonialPage,
        ValidacaoConsistenciaBalancoDVPPage,
        ValidacaoConsistenciaBalancoDFCPage,
        AnaliseContasBancariasPage,
        SaldosDeclaradosPage,
        ValidacaoConsistenciaBalancoFinanceiroPage,
        CruzamentoBalancoFinanceiroPatrimonialPage,
        ResumoAnalisePage,
        MyFilterPipe,
        TipoContaFilter,
        TipoBancoFilter,
        FiltroProcessoPipe,
        FiltroRespostaValor,
        OrderrByPipe,
        ResumoRelatorioInspecaoPage,
        AnaliseSaldosViradosPatrimonialSPEDPage,
        ListaContratosPage,
        AcrescimosOuSupressoesContratosVersusLimiteLegalPage,
        ExtensaoPrazosContratuaisAcimaLimiteRegulamentadoPage,
        NotaEmpenhoAnteriorAAssinaturaContratoPage,
        NotaEmpenhoAnteriorAPublicacaoContratoPage,
        NotaEmpenhoPosteriorAVigenciaContratoPage,
        RegistroDespesasSemContratoDesacordoArt62Page,
        ValidacaoDataPublicacaoPage,
        CargoPage,
        BensServicosPage,
        LicitacaoResumoAnalisePage,
        DirecionamentoFornecedoresPage,
        LicitacaoRelatorioInspecaoPage,
        VisaoGerencialPage,
        VisaoGerencialPessoalPage,
        VisaoGerencialElemento31Page,
        BensServicosConviteTomadaConcorrenciaPage,
        BensServicosNaoEnquadramPage,
        DispensaLicitacaoIncompativelPage,
        InexigibilidadePage,
        PessoalResumoAnalisePage,
        PessoalAnaliseHorizontalPage,
        AquisicaoBensPage,
        AnaliseMetasPage,
        AquisicaoBensPage,
        ExecucaoXMetasPage,
        ExerciciosAnterioresPage,
        PessoalAnaliseVerticalPage,
        PessoalNomeacaoVersusParametrizacaoPage,
        PessoalNomeacaoVersusSRPPage,
        PessoalVersusNomeacaoPage,
        PessoalQuadroPessoalPage,
        PessoalTermosReferenciaContratoPage,
        PessoalQuadroNomeacaoCargosPage,
        OutrosServicosLimiteDispensaPage,
        ModalidadeVersusContratadoPage,
        ObrasAcimaLimitePage,
        PessoalDemQuadroPessoallPage,
        PessoalContratosTerceirizacaolPage,
        MonitoramentoDecisoesResumoAnalisePage,
        MonitoramentoDecisoesPage,
        TomadaDeContaResumoAnalisePage,
        TomadaDeContaPage,
        TCEForaDoPrazoPage,
        TCEConveniosPrestacaoPendentesPage,
        TCENaoEnviadoPage,
        ConvenioResumoAnalisePage,
        ConvenioRelacaoCelebradosPage,
        ConvenioComunicacaoInadimplenciaPage,
        MateriaisResumoAnalisePage,
        BensMateriaisMoveisPage,
        BensMateriaisImoveisPage,
        BensMateriaisIntangiveisPage,
        MateriaisConsumoPage,
        AlienacaoBensImoveisPage,
        AlienacaoBensMoveisPage,
        BensDoacaoPage,
        EspeciesProcessuaisPage,
        ArquivosPage,
        ContabilidadeResumoAnalisePage,
        ContratosGestaoResumoAnalisePage,
        CadastroContratosPage,
        RolResponsaveisCGPage,
        TransferenciaRecursosPage,
        RelatorioReceitasDespesasPage,
        RelatorioPagamentosPage,
        RelatorioFisicoFinanceiroPage,
        RelatorioEditaisCotacoesPage,
        PessoalVinculadoPage,
        FonteDiferencaFilter,
        ControlesinternosValidator,
        ResumoRelatorioInspecaoConveniosPage,
        AnaliseDespesasPage,
        PagamentosDesacordoCompraPage,
        PagamentosVsPessoalPage,
        ParcelasRecebidasVsEmpenhoPage,
        RelatorioFisicoPage,
        PessoalVinculadoCGPage,
        ServidoresContempladosPagamentosPage,
        RelatorioReceitaDespesaPage,
        TransferenciaRecursosAnalistaPage,
        VerificacaoContratacaoPage,
        VerificacaoRolPage,
        CelebracaoInadimplentePage,
        ParcelaUnicaPage,
        ApresentacaoFPrazoPage,
        SaldoRemanescentePage,
        PrestacaoSuperiorPage,
        SaldosADevolverPage,
        PrestacaoForaPrazoPage,
        CelebracaoAtrasoPage,
        RegistroIncorretoPage,
        ConveniosInadimplenciaPage,
        ComunicacaoInadimplenciaPage,
        DesconformidadePublicacaoPage,
        EmpenhoAssinaturaPage,
        EmpenhoPublicacaoPage,
        EmpenhoVigenciaPage,
        RelatorioAuditoriaCGEPage,
        MedidasForaPrazoPage,
        //GroupByPipe
        BaixaVsAquisicaoPage,
        BaixaVsSaldoAtualPage,
        ReconhecimentoResultadoPage,
        AlienacoesDoacoesPage,
        SaldosContabeisPage,
        SaldosContabeisTabelasVsBalancetePage,
        diferencaDotacoesPage,
        consolidacaoDespesasPage,
        ValidacaoContasTotalizadorasBalancoFinanceiroPage,
        ValidacaoContasTotalizadorasBalancoOrcamentarioPage,
        ValidacaoContasTotalizadorasBalancoPatrimonialPage,
        ValidacaoContasTotalizadorasDemonstrativoFluxoCaixaPage,
        ValidacaoContasTotalizadorasDVPPage,
        AnaliseIndicadoresPage,
        OrdinariaVsVinculadaPage,
        SaldoContasAnaliticasPage,
        AnalisePrevisaoInicialContasAnaliticasPage,
        ExecucaoRestosPagarProcessadosLiquidadosPage,
        AnaliseSaldosViradosDVPPage,
        AnaliseSaldosViradosFinanceiroPage,
        AnaliseSaldosViradosDemonstrativoFluxoCaixaPage,
        AnaliseSaldosViradosPatrimonialPage,
        AnaliseSaldosViradosOrcamentarioPage,
        TotalRestosPagarProcessadosPage,
        AnaliseHorizontalBalancoPatrimonialEGEPage,
        AnaliseHorizontalBalancoDvpEGEPage,
        AnaliseVerticalBalancoPatrimonialEGEPage,
        AnaliseVerticalBalancoPatrimonialSpedPage,
        AnaliseHorizontalBalancoFinanceiroEGEPage,
        AnaliseHorizontalDemonstrativoFluxoCaixaEGEPage,
        ExecucaoRestosPagarEGEPage,
        ValoresRestituiveisEGEPage,
        SaldoCaixaEGEPage,
        SaldoContaEGEPage,
        ValidacaoConsistenciaBalancoDFCEGEPage,
        ValidacaoConsistenciaBalancoPatrimonialEGEPage,
        ValidacaoConsistenciaBalancoDVPEGEPage,
        ValidacaoConsistenciaBalancoFinanceiroEGEPage,
        CruzamentoBalancoFinanceiroPatrimonialEGEPage,
        TotalRestosPagarNaoProcessadosEGEPage,
        ExecucaoRestosPagarNaoProcessadosEGEPage,
        AnaliseContasBancariasEGEPage,
        SaldosDeclaradosEGEPage,
        ValidacaoContasTotalizadorasBalancoFinanceiroEGEPage,
        ValidacaoContasTotalizadorasBalancoOrcamentarioEGEPage,
        ValidacaoContasTotalizadorasBalancoPatrimonialEGEPage,
        ValidacaoContasTotalizadorasBalancoPatrimonialSPEDPage,
        ValidacaoContasTotalizadorasDRESPEDPage,
        ValidacaoContasTotalizadorasDemonstrativoFluxoCaixaEGEPage,
        ValidacaoContasTotalizadorasDVPEGEPage,
        AnalisePrevisaoInicialContasAnaliticasEGEPage,
        AnaliseIndicadoresEGEPage,
        ExecucaoRestosPagarProcessadosLiquidadosEGEPage,
        AnaliseSaldosViradosDVPEGEPage,
        AnaliseSaldosViradosFinanceiroEGEPage,
        AnaliseSaldosViradosDemonstrativoFluxoCaixaEGEPage,
        AnaliseSaldosViradosPatrimonialEGEPage,
        AnaliseSaldosViradosOrcamentarioEGEPage,
        TotalRestosPagarProcessadosEGEPage,
        SaldoContasAnaliticasEGEPage,
        OrdinariaVsVinculadaEGEPage,
        AnaliseHorizontalBalancoPatrimonialSpedPage,
        ValidacaoConsistenciaBalancoPatrimonialSPEDPage

    ],
    imports: [
        IonicModule.forRoot(DadosGeraisPage),
        // TooltipModule.forRoot(),
        FormsModule,
        TextMaskModule,
        MyDatePickerModule,
        MyDateRangePickerModule,
        NgxPaginationModule,
        OrderModule,
        NgPipesModule,
        CurrencyMaskModule,
        NgSelectModule,
        PipesModule,
        QuillModule,
        AssinaturaModule        
    ],
    bootstrap: [
        IonicApp
    ],
    entryComponents: [
        ControlesInternosPage,
        RolResponsaveisPage,
        RolAssinantesPage,
        CadastroAssinantesPage,
        DadosGeraisPage,
        ProcessosCorrelatosPage,
        RelatoriosContabeisPage,
        // OrcamentoPage,
        OrcamentoResumoAnalisePage,
        ContasBancariasPage,
        ContratosPage,
        AnaliseHorizontalBalancoPatrimonialPage,
        AnaliseHorizontalBalancoDvpPage,
        AnaliseVerticalBalancoPatrimonialPage,
        AnaliseHorizontalBalancoFinanceiroPage,
        AnaliseHorizontalDemonstrativoFluxoCaixaPage,
        ExecucaoRestosPagarPage,
        ValoresRestituiveisPage,
        SaldoCaixaPage,
        TotalRestosPagarNaoProcessadosPage,
        ExecucaoRestosPagarNaoProcessadosPage,
        SaldoContaPage,
        SaldoContaSPEDPage,
        ValidacaoConsistenciaBalancoPatrimonialPage,
        ValidacaoConsistenciaBalancoDVPPage,
        ValidacaoConsistenciaBalancoDFCPage,
        AnaliseContasBancariasPage,
        SaldosDeclaradosPage,
        ValidacaoConsistenciaBalancoFinanceiroPage,
        CruzamentoBalancoFinanceiroPatrimonialPage,
        ResumoAnalisePage,
        ResumoRelatorioInspecaoPage,
        ListaContratosPage,
        AcrescimosOuSupressoesContratosVersusLimiteLegalPage,
        ExtensaoPrazosContratuaisAcimaLimiteRegulamentadoPage,
        NotaEmpenhoAnteriorAAssinaturaContratoPage,
        NotaEmpenhoAnteriorAPublicacaoContratoPage,
        NotaEmpenhoPosteriorAVigenciaContratoPage,
        RegistroDespesasSemContratoDesacordoArt62Page,
        ValidacaoDataPublicacaoPage,
        CargoPage,
        BensServicosPage,
        LicitacaoResumoAnalisePage,
        DirecionamentoFornecedoresPage,
        LicitacaoRelatorioInspecaoPage,
        VisaoGerencialPage,
        VisaoGerencialPessoalPage,
        VisaoGerencialElemento31Page,
        BensServicosConviteTomadaConcorrenciaPage,
        BensServicosNaoEnquadramPage,
        DispensaLicitacaoIncompativelPage,
        InexigibilidadePage,
        PessoalResumoAnalisePage,
        PessoalAnaliseHorizontalPage,
        AquisicaoBensPage,
        AnaliseMetasPage,
        AquisicaoBensPage,
        ExecucaoXMetasPage,
        ExerciciosAnterioresPage,
        PessoalAnaliseVerticalPage,
        PessoalNomeacaoVersusParametrizacaoPage,
        PessoalNomeacaoVersusSRPPage,
        PessoalVersusNomeacaoPage,
        PessoalQuadroPessoalPage,
        PessoalTermosReferenciaContratoPage,
        PessoalQuadroNomeacaoCargosPage,
        OutrosServicosLimiteDispensaPage,
        ModalidadeVersusContratadoPage,
        ObrasAcimaLimitePage,
        PessoalDemQuadroPessoallPage,
        PessoalContratosTerceirizacaolPage,
        MonitoramentoDecisoesResumoAnalisePage,
        MonitoramentoDecisoesPage,
        TomadaDeContaResumoAnalisePage,
        TomadaDeContaPage,
        AnaliseSaldosViradosPatrimonialSPEDPage,
        TCEForaDoPrazoPage,
        TCEConveniosPrestacaoPendentesPage,
        TCENaoEnviadoPage,
        ConvenioResumoAnalisePage,
        ConvenioRelacaoCelebradosPage,
        ConvenioComunicacaoInadimplenciaPage,
        MateriaisResumoAnalisePage,
        MateriaisConsumoPage,
        BensMateriaisMoveisPage,
        BensMateriaisImoveisPage,
        BensMateriaisIntangiveisPage,
        AlienacaoBensImoveisPage,
        AlienacaoBensMoveisPage,
        BensDoacaoPage,
        EspeciesProcessuaisPage,
        ArquivosPage,
        ContabilidadeResumoAnalisePage,
        ContratosGestaoResumoAnalisePage,
        CadastroContratosPage,
        RolResponsaveisCGPage,
        TransferenciaRecursosPage,
        RelatorioReceitasDespesasPage,
        RelatorioPagamentosPage,
        RelatorioFisicoFinanceiroPage,
        RelatorioEditaisCotacoesPage,
        PessoalVinculadoPage,
        ResumoRelatorioInspecaoConveniosPage,
        AnaliseDespesasPage,
        PagamentosDesacordoCompraPage,
        PagamentosVsPessoalPage,
        ParcelasRecebidasVsEmpenhoPage,
        RelatorioFisicoPage,
        PessoalVinculadoCGPage,
        ServidoresContempladosPagamentosPage,
        RelatorioReceitaDespesaPage,
        TransferenciaRecursosAnalistaPage,
        VerificacaoContratacaoPage,
        VerificacaoRolPage,
        CelebracaoInadimplentePage,
        ParcelaUnicaPage,
        ApresentacaoFPrazoPage,
        SaldoRemanescentePage,
        PrestacaoSuperiorPage,
        SaldosADevolverPage,
        PrestacaoForaPrazoPage,
        CelebracaoAtrasoPage,
        RegistroIncorretoPage,
        ConveniosInadimplenciaPage,
        ComunicacaoInadimplenciaPage,
        DesconformidadePublicacaoPage,
        EmpenhoAssinaturaPage,
        EmpenhoPublicacaoPage,
        EmpenhoVigenciaPage,
        BaixaVsAquisicaoPage,
        BaixaVsSaldoAtualPage,
        ReconhecimentoResultadoPage,
        AlienacoesDoacoesPage,
        RelatorioAuditoriaCGEPage,
        MedidasForaPrazoPage,
        SaldosContabeisPage,
        SaldosContabeisTabelasVsBalancetePage,
        diferencaDotacoesPage,
        consolidacaoDespesasPage,
        ValidacaoContasTotalizadorasBalancoFinanceiroPage,
        ValidacaoContasTotalizadorasBalancoOrcamentarioPage,
        ValidacaoContasTotalizadorasBalancoPatrimonialPage,
        ValidacaoContasTotalizadorasDemonstrativoFluxoCaixaPage,
        ValidacaoContasTotalizadorasDVPPage,
        AnaliseIndicadoresPage,
        OrdinariaVsVinculadaPage,
        SaldoContasAnaliticasPage,
        AnalisePrevisaoInicialContasAnaliticasPage,
        ExecucaoRestosPagarProcessadosLiquidadosPage,
        AnaliseSaldosViradosDVPPage,
        AnaliseSaldosViradosFinanceiroPage,
        AnaliseSaldosViradosDemonstrativoFluxoCaixaPage,
        AnaliseSaldosViradosPatrimonialPage,
        AnaliseSaldosViradosOrcamentarioPage,
        TotalRestosPagarProcessadosPage,
        AnaliseHorizontalBalancoPatrimonialEGEPage,
        AnaliseHorizontalBalancoDvpEGEPage,
        AnaliseVerticalBalancoPatrimonialEGEPage,
        AnaliseVerticalBalancoPatrimonialSpedPage,
        AnaliseHorizontalBalancoFinanceiroEGEPage,
        AnaliseHorizontalDemonstrativoFluxoCaixaEGEPage,
        ExecucaoRestosPagarEGEPage,
        ValoresRestituiveisEGEPage,
        SaldoCaixaEGEPage,
        SaldoContaEGEPage,
        ValidacaoConsistenciaBalancoDFCEGEPage,
        ValidacaoConsistenciaBalancoPatrimonialEGEPage,
        ValidacaoConsistenciaBalancoDVPEGEPage,
        ValidacaoConsistenciaBalancoFinanceiroEGEPage,
        CruzamentoBalancoFinanceiroPatrimonialEGEPage,
        TotalRestosPagarNaoProcessadosEGEPage,
        ExecucaoRestosPagarNaoProcessadosEGEPage,
        AnaliseContasBancariasEGEPage,
        SaldosDeclaradosEGEPage,
        ValidacaoContasTotalizadorasBalancoFinanceiroEGEPage,
        ValidacaoContasTotalizadorasBalancoOrcamentarioEGEPage,
        ValidacaoContasTotalizadorasBalancoPatrimonialEGEPage,
        ValidacaoContasTotalizadorasBalancoPatrimonialSPEDPage,
        ValidacaoContasTotalizadorasDRESPEDPage,
        ValidacaoContasTotalizadorasDemonstrativoFluxoCaixaEGEPage,
        ValidacaoContasTotalizadorasDVPEGEPage,
        AnalisePrevisaoInicialContasAnaliticasEGEPage,
        AnaliseIndicadoresEGEPage,
        ExecucaoRestosPagarProcessadosLiquidadosEGEPage,
        AnaliseSaldosViradosDVPEGEPage,
        AnaliseSaldosViradosFinanceiroEGEPage,
        AnaliseSaldosViradosDemonstrativoFluxoCaixaEGEPage,
        AnaliseSaldosViradosPatrimonialEGEPage,
        AnaliseSaldosViradosOrcamentarioEGEPage,
        TotalRestosPagarProcessadosEGEPage,
        SaldoContasAnaliticasEGEPage,
        OrdinariaVsVinculadaEGEPage,
        AnaliseHorizontalBalancoPatrimonialSpedPage,
        ValidacaoConsistenciaBalancoPatrimonialSPEDPage
    ],
    exports: [
        DadosGeraisPage
    ],
    providers: [
        { provide: ErrorHandler, useClass: IonicErrorHandler }
    ]
})
export class ModulosModule {

}



// WEBPACK FOOTER //
// ./src/pages/modulos/modulos.module.ts